function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M278.944,17.577c-5.568-2.656-12.128-1.952-16.928,1.92L106.368,144.009H32c-17.632,0-32,14.368-32,32v128 c0,17.664,14.368,32,32,32h74.368l155.616,124.512c2.912,2.304,6.464,3.488,10.016,3.488c2.368,0,4.736-0.544,6.944-1.6 c5.536-2.656,9.056-8.256,9.056-14.4v-416C288,25.865,284.48,20.265,278.944,17.577z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M368.992,126.857c-6.304-6.208-16.416-6.112-22.624,0.128c-6.208,6.304-6.144,16.416,0.128,22.656 C370.688,173.513,384,205.609,384,240.009s-13.312,66.496-37.504,90.368c-6.272,6.176-6.336,16.32-0.128,22.624 c3.136,3.168,7.264,4.736,11.36,4.736c4.064,0,8.128-1.536,11.264-4.64C399.328,323.241,416,283.049,416,240.009 S399.328,156.777,368.992,126.857z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M414.144,81.769c-6.304-6.24-16.416-6.176-22.656,0.096c-6.208,6.272-6.144,16.416,0.096,22.624 C427.968,140.553,448,188.681,448,240.009s-20.032,99.424-56.416,135.488c-6.24,6.24-6.304,16.384-0.096,22.656 c3.168,3.136,7.264,4.704,11.36,4.704c4.064,0,8.16-1.536,11.296-4.64C456.64,356.137,480,299.945,480,240.009 S456.64,123.881,414.144,81.769z"
});
var _ref5 = /*#__PURE__*/React.createElement("g", null);
var _ref6 = /*#__PURE__*/React.createElement("g", null);
var _ref7 = /*#__PURE__*/React.createElement("g", null);
var _ref8 = /*#__PURE__*/React.createElement("g", null);
var _ref9 = /*#__PURE__*/React.createElement("g", null);
var _ref10 = /*#__PURE__*/React.createElement("g", null);
var _ref11 = /*#__PURE__*/React.createElement("g", null);
var _ref12 = /*#__PURE__*/React.createElement("g", null);
var _ref13 = /*#__PURE__*/React.createElement("g", null);
var _ref14 = /*#__PURE__*/React.createElement("g", null);
var _ref15 = /*#__PURE__*/React.createElement("g", null);
var _ref16 = /*#__PURE__*/React.createElement("g", null);
var _ref17 = /*#__PURE__*/React.createElement("g", null);
var _ref18 = /*#__PURE__*/React.createElement("g", null);
var _ref19 = /*#__PURE__*/React.createElement("g", null);
const SvgVolume = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVolume, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/volume.ed930085.svg";
export { ForwardRef as ReactComponent };